import { Component, HostBinding, Input } from '@angular/core';
import { Border, borderToStyle } from 'shared/design-system/data-access/border';
import {
    MinSize,
    PaddingSize,
    PxSize,
    RemSize,
    VarSize,
} from 'shared/design-system/data-access/layout';
import { BreakpointEnum } from 'shared/design-system/data-access/responsive';
import { ColorEnum } from 'shared/design-system/data-access/theme';

@Component({
    selector: 'it-columns',
    imports: [],
    templateUrl: './columns.component.html',
    styleUrls: ['./columns.component.scss'],
})
export class ColumnsComponent {
    @Input({ required: true }) template!: { amount: number; size?: string }[];
    @Input() gap?: RemSize = '2rem';
    @Input() padding?: PaddingSize = '2rem';
    @Input() size?: string;
    @Input() backgroundColor?: ColorEnum;
    @Input() color?: ColorEnum;
    @Input() border?: Border;
    @Input() overflowX?: 'auto';
    @Input() clampWidth?: PxSize | BreakpointEnum | VarSize | MinSize;

    @HostBinding('style.grid-template-columns')
    get gridTemplateColumns() {
        return this.template
            .map(
                (config) =>
                    `repeat(${config.amount.toString()}, ${config.size ?? '1fr'})`,
            )
            .join(' ');
    }

    @HostBinding('style.gap')
    get gapStyle() {
        return this.gap;
    }

    @HostBinding('style.padding')
    get paddingStyle() {
        return this.padding;
    }

    @HostBinding('style.background-color')
    get backgroundColorStyle() {
        return this.backgroundColor;
    }

    @HostBinding('style.color')
    get colorStyle() {
        return this.color;
    }

    @HostBinding('style.border-top')
    get borderTop() {
        return borderToStyle(this.border)?.borderTop;
    }

    @HostBinding('style.border-right')
    get borderRight() {
        return borderToStyle(this.border)?.borderRight;
    }

    @HostBinding('style.border-bottom')
    get borderBottom() {
        return borderToStyle(this.border)?.borderBottom;
    }

    @HostBinding('style.border-left')
    get borderLeft() {
        return borderToStyle(this.border)?.borderLeft;
    }

    @HostBinding('style.width')
    get widthStyle() {
        return this.clampWidth ? `min(${this.clampWidth},100%)` : undefined;
    }

    @HostBinding('style.max-width')
    get maxWidthStyle() {
        return this.clampWidth;
    }

    @HostBinding('style.overflow-x')
    get overflowXStyle() {
        return this.overflowX;
    }
}
